import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import Icon from 'components/Icon';
import { Link } from 'react-router-dom';

interface QuickAction {
  title: string;
  description: string;
  icon: string;
  to: string;
  iconColor?: string;
}

interface QuickActionsCardProps {
  actions: QuickAction[];
}

const QuickActionsCard = ({ actions }: QuickActionsCardProps) => {
  return (
    <Card className="border-0 shadow-sm h-100">
      <CardHeader className="bg-white border-0 pt-4 pb-2">
        <h5 className="mb-0 fw-bold">
          <Icon icon="lightning-charge" className="me-2 text-warning" />
          Ações Rápidas
        </h5>
      </CardHeader>
      <CardBody className="pt-0">
        <ListGroup flush>
          {actions.map((action, index) => (
            <ListGroupItem
              key={index}
              tag={Link}
              to={action.to}
              action
              className="border-0 d-flex align-items-center py-3 px-0"
            >
              <div
                className="rounded d-flex align-items-center justify-content-center me-3 bg-light"
                style={{ width: '40px', height: '40px', minWidth: '40px' }}
              >
                <Icon
                  icon={action.icon}
                  className={action.iconColor || 'text-primary'}
                  width={20}
                  height={20}
                />
              </div>
              <div>
                <p className="mb-0 fw-semibold">{action.title}</p>
                <small className="text-muted">{action.description}</small>
              </div>
              <Icon icon="chevron-right" className="ms-auto text-muted" />
            </ListGroupItem>
          ))}
        </ListGroup>
      </CardBody>
    </Card>
  );
};

export default QuickActionsCard;
